import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { transactions } from 'data/actions';
import Price from 'components/Formaters/Price';
import Row from 'components/Form/Row';
import Field from 'components/Form/Field';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';


class TransationFormDialog extends Component {

  static contextTypes = {
    router: PropTypes.object
  };

  state = { open: false };
  
  componentDidMount () {

  }

  openDialog = (e) => {
    if (e)
    {
      e.preventDefault();
    }
    var state = {...this.state, open: true};
    this.setState(state);
  }

  closeDialog = (event) => {
    var state = {...this.state, open: false};
    this.setState(state);
  }  

  saveTransaction = (event) => {
    var data = _.map(this.refs, (r,i) => { console.log(i, r.state.value); return {[i]: r.state.value || ""} });
    let merged = Object.assign(...data);
    this.props.actions.addTransaction(this.props.accountid, merged, this.closeDialog);
  }

  

  render () {
    const actions = [
      <FlatButton label="Avbryt" primary={true} onTouchTap={this.closeDialog} />,
      <FlatButton label="Spara" primary={true} keyboardFocused={true} onTouchTap={this.saveTransaction}/>,
    ];
    return ( 
      <Dialog title="Skapa transaktion" actions={actions} modal={false} open={this.state.open} >
        <Row>
          <Field floatingLabelText="Beskrivning" ref="description" value="" />
        </Row>
        <Row>
          <Field floatingLabelText="Belopp" ref="amount" value="" />
        </Row>
      </Dialog>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
  };
}
const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators({...transactions }, dispatch)
  };
}
export default connect(mapStateToProps, mapDispatch, null, {withRef:true})(TransationFormDialog)

  



// WEBPACK FOOTER //
// ./src/components/Balance/TransationFormDialog.jsx